import {
  FabMenuItemsTypes,
  FabMenuPropertiesTypes
} from "@website/ui/fab-menu/fab-bar.type";
import get from "lodash-es/get";
import toString from "lodash-es/toString";
import { useRouter } from "next/router";
import { useCallback, useEffect, useState } from "react";

export const useTopBar = ({ items }: FabMenuPropertiesTypes) => {
  const router = useRouter();
  const [scrolledItem, setScrolledItem] = useState("");
  const [scrolledItems, setScrolledItems] = useState({});
  const [clickedItem, setClickedItem] = useState<Record<string, string>>({});
  const handleClick = useCallback(
    (item: FabMenuItemsTypes) => () => {
      setClickedItem(item);
      window?.scrollTo({
        top:
          (document.querySelector<HTMLDivElement>(item?.selector)
            ?.offsetTop as number) -
          (process.env.NEXT_PUBLIC_APP_NAME === "villa" ? 15 : 55),
        behavior: "smooth"
      });
    },
    []
  );

  useEffect(() => {
    const list = items?.map(({ selector }) => {
      const element = document.querySelector<HTMLDivElement>(selector);

      const observer = new IntersectionObserver(
        ([entry]) => {
          clickedItem?.title
            ? setScrolledItems((state) => ({
                ...Object.fromEntries(
                  Object.keys(state).map((key) => [key, false])
                ),
                [clickedItem?.selector]: true
              }))
            : setScrolledItems((state) => ({
                ...state,
                [selector]: entry.isIntersecting
              }));
        },
        {
          threshold:
            process.env.NEXT_PUBLIC_APP_NAME === "villa" ? 0.5 : undefined
        }
      );
      element && observer?.observe(element);
      return () => {
        element && observer?.unobserve(element);
      };
    });
    return () => void list?.map((unobserve) => unobserve());
  }, [handleClick, items, router?.query, clickedItem]);
  useEffect(() => {
    if (clickedItem?.title)
      window.addEventListener("scrollend", () => {
        setClickedItem({});
      });
  }, [setScrolledItem, scrolledItems]);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      setScrolledItem(
        toString(
          items?.find(({ selector }) => get(scrolledItems, selector) === true)
            ?.title
        )
      );
    });
  }, [items, scrolledItems]);

  return {
    scrolledItem,
    handleClick
  };
};
